require('./brokerMarketsPulsesView.scss');

const PropTypes = require('prop-types');

//@vendors
const React = require('react');
const { connect } = require('react-redux');
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;

//@commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { ContentBox } = require('commonsComponents/contentBox');
const PulsesColumn = require('components/commons/broker/pulses/pulsesColumn');
const MoreNews = require('components/commons/broker/news/moreNews');

//@utils
const {
    BROKER_MAX_MORE_NEWS
} = require('constants/index');

//@actions
const marketPulsesActions = require('actions/brokerMarketPulses');
const newsActions = require('actions/brokerNews');

class BrokerMarketsPulsesView extends React.Component {
    componentDidMount() {
        this.props.requestNews(BROKER_MAX_MORE_NEWS);
    }
    render() {
        const {
            immMarketsPulses,
            requestMarketPulses,
            immBrokerNews,
            requestNews
        } = this.props;
        const breadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('breadcrumb-brokerMarkets'),
                url: '/myprofile/broker/markets'
            },
            {
                text: formatText('breadcrumb-brokerPulses'),
                url: ''
            }
        ];

        return (
            <div className="broker-markets-pulses-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumb}
                        finalTitle={getFinalTitle('breadcrumb-brokerPulses')}
                    />
                </OKCover>
                <section className="broker-markets-pulses-view__body">
                    <div className="row no-outside-gutter">
                        <div className="col-lg-8">
                            <ContentBox
                                title={formatText('broker-lastPulsesViewTitle')}
                                smallTitle={true}
                                titleSeparator={true}
                            >
                                <PulsesColumn
                                    immMarketsPulses={immMarketsPulses}
                                    requestMarketPulses={requestMarketPulses}
                                    maxPulses={5}
                                />
                            </ContentBox>
                        </div>
                        <div className="col-lg-4">
                            <ContentBox
                                title={formatText('broker-lastPulsesViewRightColumnTitle')}
                                smallTitle={true}
                            >
                                <MoreNews
                                    immBrokerNews={immBrokerNews}
                                    requestNews={requestNews}
                                />
                            </ContentBox>
                        </div>
                        <div className="col-lg-12 broker-markets-pulses-view__footer-disclaimer">
                            <div className="broker-markets-pulses-view__disclaimer-paragraph">
                                <FormattedText value="broker-disclaimerTextFirstParagraph" />
                            </div>
                            <div className="broker-markets-pulses-view__disclaimer-paragraph">
                                <FormattedText value="broker-disclaimerTextSecondParagraph" />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


BrokerMarketsPulsesView.propTypes = {
    immBrokerNews: PropTypes.object,
    immMarketsPulses: PropTypes.object,
    requestMarketPulses: PropTypes.func.isRequired,
    requestNews: PropTypes.func.isRequired,
};

module.exports.constructor = BrokerMarketsPulsesView;
module.exports.BrokerMarketsPulsesView = connect(
    state => ({
        immMarketsPulses: state.brokerMarketsPulses,
        immBrokerNews: state.brokerNews
    }), {
        requestMarketPulses: marketPulsesActions.requestMarketPulses,
        requestNews: newsActions.requestNews
    })(BrokerMarketsPulsesView);
